import { AppInfo } from "./../models";
import { createEventEmitter, EventEmitter } from "./utils";
import { context } from "./context";
import { appStore } from "./app-store";

class Workflow {
  private _navigateEvent: EventEmitter = createEventEmitter();

  get navigateEvent(): EventEmitter {
    return this._navigateEvent;
  }

  constructor() {
    appStore.changedEvent.subscribe((app: AppInfo) => this.setActionHandler(app));
    context.actionEvent.subscribe((action: string, _: any, url: string) => this.handleAction(action, url));
  }

  private handleAction(action: string, url: string): void {
    if (action!=="refreshToken") {
      const handlers = <AppInfo[]>(context.get(action) || []);
      if (handlers.length > 0) {
        const app = handlers[0];
        app.lastVisitedRoute = url;
        this._navigateEvent.emit(app.id);
      }
    }
  }

  setActionHandler(app: AppInfo): void {
    const actions: string[] = app.triggerActions || [];
    actions.forEach((action: string) => {
      let handlers: AppInfo[] = (<AppInfo[]>(context.get(action) || [])).filter(x => x.id !== app.id);
      handlers = app.alive ? [...handlers, app] : handlers;
      context.set(action, handlers.length > 0 ? handlers : null);
    });
  }
}

export const workflow = new Workflow();
